(function() { module.exports = this["wp"]["i18n"]; }());


//////////////////
// WEBPACK FOOTER
// external {"this":["wp","i18n"]}
// module id = 55
// module chunks = 0 1